import { render, staticRenderFns } from "./dashboard_best_sale_product.vue?vue&type=template&id=3f5078c7&scoped=true"
import script from "./dashboard_best_sale_product.vue?vue&type=script&lang=js"
export * from "./dashboard_best_sale_product.vue?vue&type=script&lang=js"
import style0 from "./dashboard_best_sale_product.vue?vue&type=style&index=0&id=3f5078c7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f5078c7",
  null
  
)

export default component.exports